import {
  GetAttendanceIncidentAggregateShiftLocationsDocument,
  GetAttendanceIncidentAggregateShiftLocationsQuery,
  GetAttendanceIncidentAggregateShiftLocationsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type aggregateShiftLocationType =
  GetAttendanceIncidentAggregateShiftLocationsQuery['attendance']['incidentAggregateShiftLocations'][number]

export const useGetAttendanceIncidentAggregateShiftLocations = (
  variables: GetAttendanceIncidentAggregateShiftLocationsQueryVariables,
  skip: boolean
) => {
  const { loading, data } = useQuery(GetAttendanceIncidentAggregateShiftLocationsDocument, {
    variables,
    skip,
  })

  const aggregateShiftLocations = data ? data.attendance.incidentAggregateShiftLocations : []

  return {
    loading,
    aggregateShiftLocations,
  }
}
